let host = process.env.REACT_APP_API_SERVER;

// get country
export const fetchCountryRequest = () => ({
    type: "FETCH_COUNTRY_DATA_REQUEST",
});

export const fetchCountrySuccess = (data) => ({
    type: "FETCH_COUNTRY_DATA_SUCCESS",
    payload: data,
});

export const fetchCountryFailure = (error) => ({
    type: "FETCH_COUNTRY_DATA_FAILURE",
    payload: error,
});

export const getCountryData = () =>

    async (dispatch) => {

        dispatch(fetchCountryRequest());
        try {


            let response = await fetch(`${host}/api/master/country_list`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchCountrySuccess(desired_data));

        } catch (error) {
            dispatch(fetchCountryFailure(error.message));
        }
    }


// get state
export const fetchStateDataRequest = () => ({
    type: "FETCH_STATE_DATA_REQUEST",
});

export const fetchStateDataSuccess = (data) => ({
    type: "FETCH_STATE_DATA_SUCCESS",
    payload: data,
});

export const fetchStateDataFailure = (error) => ({
    type: "FETCH_STATE_DATA_FAILURE",
    payload: error,
});

export const getStateData = (id) =>

    async (dispatch) => {

        dispatch(fetchStateDataRequest());
        try {


            let response = await fetch(`${host}/api/master/state_list?country_id=${id}`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchStateDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchStateDataFailure(error.message));
        }
    }


// get city
export const fetchCityDataRequest = () => ({
    type: "FETCH_CITY_DATA_REQUEST",
});

export const fetchCityDataSuccess = (data) => ({
    type: "FETCH_CITY_DATA_SUCCESS",
    payload: data,
});

export const fetchCityDataFailure = (error) => ({
    type: "FETCH_CITY_DATA_FAILURE",
    payload: error,
});

export const getCityData = (id) =>

    async (dispatch) => {

        dispatch(fetchCityDataRequest());
        try {


            let response = await fetch(`${host}/api/master/city_list?state_id=${id}`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchCityDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchCityDataFailure(error.message));
        }
    }



// website management data
export const fetchWebsiteManagementDataRequest = () => ({
    type: "FETCH_WEBSITE_MANAGEMENT_DATA_REQUEST",
});

export const fetchWebsiteManagementDataSuccess = (data) => ({
    type: "FETCH_WEBSITE_MANAGEMENT_DATA_SUCCESS",
    payload: data,
});

export const fetchWebsiteManagementDataFailure = (error) => ({
    type: "FETCH_WEBSITE_MANAGEMENT_DATA_FAILURE",
    payload: error,
});

export const getWebsiteManagementData = () =>

    async (dispatch) => {

        dispatch(fetchWebsiteManagementDataRequest());
        try {


            let response = await fetch(`${host}/api/web/website-management-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchWebsiteManagementDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchWebsiteManagementDataFailure(error.message));
        }
    }



// website management data
export const fetchHomeBannerDataRequest = () => ({
    type: "FETCH_HOME_BANNER_DATA_REQUEST",
});

export const fetchHomeBannerDataSuccess = (data) => ({
    type: "FETCH_HOME_BANNER_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeBannerDataFailure = (error) => ({
    type: "FETCH_HOME_BANNER_DATA_FAILURE",
    payload: error,
});

export const getHomeBannerData = () =>

    async (dispatch) => {

        dispatch(fetchHomeBannerDataRequest());
        try {


            let response = await fetch(`${host}/api/web/home-banner-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeBannerDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeBannerDataFailure(error.message));
        }
    }


// home second sec data
export const fetchHomeSecondSecDataRequest = () => ({
    type: "FETCH_HOME_SECOND_SEC_DATA_REQUEST",
});

export const fetchHomeSecondSecDataSuccess = (data) => ({
    type: "FETCH_HOME_SECOND_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeSecondSecDataFailure = (error) => ({
    type: "FETCH_HOME_SECOND_SEC_DATA_FAILURE",
    payload: error,
});

export const getHomeSecondSecData = () =>

    async (dispatch) => {

        dispatch(fetchHomeSecondSecDataRequest());
        try {


            let response = await fetch(`${host}/api/web/home-section-two-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeSecondSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeSecondSecDataFailure(error.message));
        }
    }



// home ABOUT NINE sec data
export const fetchHomeAboutNineSecDataRequest = () => ({
    type: "FETCH_HOME_ABOUT_NINE_SEC_DATA_REQUEST",
});

export const fetchHomeAboutNineSecDataSuccess = (data) => ({
    type: "FETCH_HOME_ABOUT_NINE_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeAboutNineSecDataFailure = (error) => ({
    type: "FETCH_HOME_ABOUT_NINE_SEC_DATA_FAILURE",
    payload: error,
});

export const getHomeAboutNineSecData = () =>

    async (dispatch) => {

        dispatch(fetchHomeAboutNineSecDataRequest());
        try {


            let response = await fetch(`${host}/api/web/about-us-nine-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeAboutNineSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeAboutNineSecDataFailure(error.message));
        }
    }


// home ABOUT NINE sec data
export const fetchHomeSixSecDataRequest = () => ({
    type: "FETCH_HOME_SIX_SEC_DATA_REQUEST",
});

export const fetchHomeSixSecDataSuccess = (data) => ({
    type: "FETCH_HOME_SIX_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeSixSecDataFailure = (error) => ({
    type: "FETCH_HOME_SIX_SEC_DATA_FAILURE",
    payload: error,
});

export const getHomeSixSecData = () =>

    async (dispatch) => {

        dispatch(fetchHomeSixSecDataRequest());
        try {


            let response = await fetch(`${host}/api/web/home-section-six-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeSixSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeSixSecDataFailure(error.message));
        }
    }


// home ABOUT NINE sec data
export const fetchHomeSevenSecDataRequest = () => ({
    type: "FETCH_HOME_SEVEN_SEC_DATA_REQUEST",
});

export const fetchHomeSevenSecDataSuccess = (data) => ({
    type: "FETCH_HOME_SEVEN_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeSevenSecDataFailure = (error) => ({
    type: "FETCH_HOME_SEVEN_SEC_DATA_FAILURE",
    payload: error,
});

export const getHomeSevenSecData = () =>

    async (dispatch) => {

        dispatch(fetchHomeSevenSecDataRequest());
        try {


            let response = await fetch(`${host}/api/web/home-section-seven-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeSevenSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeSevenSecDataFailure(error.message));
        }
    }



// home ABOUT NINE sec data
export const fetchHomeFindTutorDataRequest = () => ({
    type: "FETCH_HOME_FIND_TUTOR_DATA_REQUEST",
});

export const fetchHomeFindTutorDataSuccess = (data) => ({
    type: "FETCH_HOME_FIND_TUTOR_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeFindTutorDataFailure = (error) => ({
    type: "FETCH_HOME_FIND_TUTOR_DATA_FAILURE",
    payload: error,
});

export const getHomeFindTutorData = () =>

    async (dispatch) => {

        dispatch(fetchHomeFindTutorDataRequest());
        try {


            let response = await fetch(`${host}/api/web/find-tutor-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeFindTutorDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeFindTutorDataFailure(error.message));
        }
    }


// home ABOUT NINE sec data
export const fetchHomeBecomeTutorDataRequest = () => ({
    type: "FETCH_HOME_BECOME_TUTOR_DATA_REQUEST",
});

export const fetchHomeBecomeTutorDataSuccess = (data) => ({
    type: "FETCH_HOME_BECOME_TUTOR_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeBecomeTutorDataFailure = (error) => ({
    type: "FETCH_HOME_BECOME_TUTOR_DATA_FAILURE",
    payload: error,
});

export const getHomeBecomeTutorData = () =>

    async (dispatch) => {

        dispatch(fetchHomeBecomeTutorDataRequest());
        try {


            let response = await fetch(`${host}/api/web/become-tutor-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeBecomeTutorDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeBecomeTutorDataFailure(error.message));
        }
    }





// Popular Tutors
export const fetchPopularTutorsDataRequest = () => ({
    type: "FETCH_POPULAR_TUTORS_DATA_REQUEST",
});

export const fetchPopularTutorsDataSuccess = (data) => ({
    type: "FETCH_POPULAR_TUTORS_DATA_SUCCESS",
    payload: data,
});

export const fetchPopularTutorsDataFailure = (error) => ({
    type: "FETCH_POPULAR_TUTORS_DATA_FAILURE",
    payload: error,
});

export const getPopularTutorsData = () =>

    async (dispatch) => {

        dispatch(fetchPopularTutorsDataRequest());
        try {


            let response = await fetch(`${host}/api/web/popular-tutor-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchPopularTutorsDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchPopularTutorsDataFailure(error.message));
        }
    }


// Testimonial
export const fetchTestimonialDataRequest = () => ({
    type: "FETCH_TESTIMONIAL_DATA_REQUEST",
});

export const fetchTestimonialDataSuccess = (data) => ({
    type: "FETCH_TESTIMONIAL_DATA_SUCCESS",
    payload: data,
});

export const fetchTestimonialDataFailure = (error) => ({
    type: "FETCH_TESTIMONIAL_DATA_FAILURE",
    payload: error,
});

export const getTestimonialData = () =>

    async (dispatch) => {

        dispatch(fetchTestimonialDataRequest());
        try {


            let response = await fetch(`${host}/api/web/testimonial-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchTestimonialDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchTestimonialDataFailure(error.message));
        }
    }



// Become Tutor Third Section Data
export const fetchBecomeTutorThirdSectionDataRequest = () => ({
    type: "FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_REQUEST",
});

export const fetchBecomeTutorThirdSectionDataSuccess = (data) => ({
    type: "FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_SUCCESS",
    payload: data,
});

export const fetchBecomeTutorThirdSectionDataFailure = (error) => ({
    type: "FETCH_BECOME_TUTOR_THIRD_SECTION_DATA_FAILURE",
    payload: error,
});

export const getBecomeTutorThirdSectionData = () =>

    async (dispatch) => {

        dispatch(fetchBecomeTutorThirdSectionDataRequest());
        try {


            let response = await fetch(`${host}/api/web/become-tutor-third-section-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchBecomeTutorThirdSectionDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchBecomeTutorThirdSectionDataFailure(error.message));
        }
    }



// Blog
export const fetchBlogDataRequest = () => ({
    type: "FETCH_BLOG_DATA_REQUEST",
});

export const fetchBlogDataSuccess = (data) => ({
    type: "FETCH_BLOG_DATA_SUCCESS",
    payload: data,
});

export const fetchBlogDataFailure = (error) => ({
    type: "FETCH_BLOG_DATA_FAILURE",
    payload: error,
});

export const getBlogData = (string) =>

    async (dispatch) => {

        dispatch(fetchBlogDataRequest());
        try {
            let response
            if (string == '') {

                response = await fetch(`${host}/api/web/blog-data`, { method: "GET" });
            }
            else {


                response = await fetch(`${host}/api/web/blog-data?searchStr=${string}`, { method: "GET" });
            }
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchBlogDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchBlogDataFailure(error.message));
        }
    }



// Blog Category Data
export const fetchBlogCategoryDataRequest = () => ({
    type: "FETCH_BLOG_CATEGORY_DATA_REQUEST",
});

export const fetchBlogCategoryDataSuccess = (data) => ({
    type: "FETCH_BLOG_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchBlogCategoryDataFailure = (error) => ({
    type: "FETCH_BLOG_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getBlogCategoryData = () =>

    async (dispatch) => {

        dispatch(fetchBlogCategoryDataRequest());
        try {


            let response = await fetch(`${host}/api/web/blog-category-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchBlogCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchBlogCategoryDataFailure(error.message));
        }
    }



//latest Blog
export const fetchLatestBlogDataRequest = () => ({
    type: "FETCH_LATEST_BLOG_DATA_REQUEST",
});

export const fetchLatestBlogDataSuccess = (data) => ({
    type: "FETCH_LATEST_BLOG_DATA_SUCCESS",
    payload: data,
});

export const fetchLatestBlogDataFailure = (error) => ({
    type: "FETCH_LATEST_BLOG_DATA_FAILURE",
    payload: error,
});

export const getLatestBlogData = () =>

    async (dispatch) => {

        dispatch(fetchLatestBlogDataRequest());
        try {


            let response = await fetch(`${host}/api/web/latest-blog-data`, { method: "GET" });
            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchLatestBlogDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchLatestBlogDataFailure(error.message));
        }
    }


// Blog
export const fetchBlogDetailDataRequest = () => ({
    type: "FETCH_BLOG_DETAIL_DATA_REQUEST",
});

export const fetchBlogDetailDataSuccess = (data) => ({
    type: "FETCH_BLOG_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchBlogDetailDataFailure = (error) => ({
    type: "FETCH_BLOG_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getBlogDetailData = (slug) =>

    async (dispatch) => {

        dispatch(fetchBlogDetailDataRequest());
        try {
            let response = await fetch(`${host}/api/web/blog-details?slug=${slug}`, { method: "GET" });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchBlogDetailDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchBlogDetailDataFailure(error.message));
        }
    }


// home tutor list data
export const fetchHomeTutorListDataRequest = () => ({
    type: "FETCH_HOME_TUTOR_LIST_DATA_REQUEST",
});

export const fetchHomeTutorListDataSuccess = (data) => ({
    type: "FETCH_HOME_TUTOR_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeTutorListDataFailure = (error) => ({
    type: "FETCH_HOME_TUTOR_LIST_DATA_FAILURE",
    payload: error,
});

export const getHomeTutorListData = (queryParams) =>

    async (dispatch) => {

        dispatch(fetchHomeTutorListDataRequest());
        try {

            let response = await fetch(`${host}/api/web/home-tutor-list?${queryParams}`, { method: "GET" });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeTutorListDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeTutorListDataFailure(error.message));
        }
    }


// home tutor list data
export const fetchHomeTutorViewDataRequest = () => ({
    type: "FETCH_HOME_TUTOR_VIEW_DATA_REQUEST",
});

export const fetchHomeTutorViewDataSuccess = (data) => ({
    type: "FETCH_HOME_TUTOR_VIEW_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeTutorViewDataFailure = (error) => ({
    type: "FETCH_HOME_TUTOR_VIEW_DATA_FAILURE",
    payload: error,
});

export const getHomeTutorViewData = (id) =>

    async (dispatch) => {

        dispatch(fetchHomeTutorViewDataRequest());
        try {

            let response = await fetch(`${host}/api/web/home-tutor-view?tutor_id=${id}`, { method: "GET" });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeTutorViewDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeTutorViewDataFailure(error.message));
        }
    }



// home category data
export const fetchHomeCategoryDataRequest = () => ({
    type: "FETCH_HOME_CATEGORY_DATA_REQUEST",
});

export const fetchHomeCategoryDataSuccess = (data) => ({
    type: "FETCH_HOME_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchHomeCategoryDataFailure = (error) => ({
    type: "FETCH_HOME_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getHomeCategoryData = () =>

    async (dispatch) => {

        dispatch(fetchHomeCategoryDataRequest());
        try {
            let response = await fetch(`${host}/api/web/home-category-data`, { method: "GET" });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchHomeCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchHomeCategoryDataFailure(error.message));
        }
    }



// sub category data
export const fetchCourseDataRequest = () => ({
    type: "FETCH_COURSE_DATA_REQUEST",
});

export const fetchCourseDataSuccess = (data) => ({
    type: "FETCH_COURSE_DATA_SUCCESS",
    payload: data,
});

export const fetchCourseDataFailure = (error) => ({
    type: "FETCH_COURSE_DATA_FAILURE",
    payload: error,
});

export const getCourseData = () =>

    async (dispatch) => {

        dispatch(fetchCourseDataRequest());
        try {
            let response = await fetch(`${host}/api/web/course-list`, { method: "GET" });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchCourseDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchCourseDataFailure(error.message));
        }
    }


// get profile data
export const fetchProfileDataRequest = () => ({
    type: "FETCH_PROFILE_DATA_REQUEST",
});

export const fetchProfileDataSuccess = (data) => ({
    type: "FETCH_PROFILE_DATA_SUCCESS",
    payload: data,
});

export const fetchProfileDataFailure = (error) => ({
    type: "FETCH_PROFILE_DATA_FAILURE",
    payload: error,
});

export const getProfileData = (authToken) =>

    async (dispatch) => {

        dispatch(fetchProfileDataRequest());
        try {

            let response = await fetch(`${host}/api/web/get-user-profile`, {
                method: "GET",
                headers: {
                    "x-auth-token": authToken, // Custom header with the token
                },
            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchProfileDataSuccess(data));

        } catch (error) {
            dispatch(fetchProfileDataFailure(error.message));
        }
    }






// get profile data
export const fetchSubCategoryDataRequest = () => ({
    type: "FETCH_SUB_CATEGORY_DATA_REQUEST",
});

export const fetchSubCategoryDataSuccess = (data) => ({
    type: "FETCH_SUB_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchSubCategoryDataFailure = (error) => ({
    type: "FETCH_SUB_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getSubCategoryData = (id) =>

    async (dispatch) => {

        dispatch(fetchSubCategoryDataRequest());
        try {

            let response = await fetch(`${host}/api/web/sub-category-data?categoryId=${id}`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchSubCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchSubCategoryDataFailure(error.message));
        }
    }




// get profile data
export const fetchChildCategoryDataRequest = () => ({
    type: "FETCH_CHILD_CATEGORY_DATA_REQUEST",
});

export const fetchChildCategoryDataSuccess = (data) => ({
    type: "FETCH_CHILD_CATEGORY_DATA_SUCCESS",
    payload: data,
});

export const fetchChildCategoryDataFailure = (error) => ({
    type: "FETCH_CHILD_CATEGORY_DATA_FAILURE",
    payload: error,
});

export const getChildCategoryData = (id) =>

    async (dispatch) => {

        dispatch(fetchChildCategoryDataRequest());
        try {


            let response = await fetch(`${host}/api/web/child-category-data?subcategoryId=${id}`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchChildCategoryDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchChildCategoryDataFailure(error.message));
        }
    }



// time slot
export const fetchTimeSlotDataRequest = () => ({
    type: "FETCH_TIME_SLOT_DATA_REQUEST",
});

export const fetchTimeSlotDataSuccess = (data) => ({
    type: "FETCH_TIME_SLOT_DATA_SUCCESS",
    payload: data,
});

export const fetchTimeSlotDataFailure = (error) => ({
    type: "FETCH_TIME_SLOT_DATA_FAILURE",
    payload: error,
});

export const getTimeSlotData = (authToken) =>

    async (dispatch) => {

        dispatch(fetchTimeSlotDataRequest());
        try {

            let response = await fetch(`${host}/api/master/time-slots`, {
                method: "GET",
                headers: {
                    "x-auth-token": authToken, // Custom header with the token
                },
            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchTimeSlotDataSuccess(data));

        } catch (error) {
            dispatch(fetchTimeSlotDataFailure(error.message));
        }
    }


// time slot
export const fetchWebsiteSettingDataRequest = () => ({
    type: "FETCH_WEBSITE_SETTING_DATA_REQUEST",
});

export const fetchWebsiteSettingDataSuccess = (data) => ({
    type: "FETCH_WEBSITE_SETTING_DATA_SUCCESS",
    payload: data,
});

export const fetchWebsiteSettingDataFailure = (error) => ({
    type: "FETCH_WEBSITE_SETTING_DATA_FAILURE",
    payload: error,
});

export const getWebsiteSettingData = () =>

    async (dispatch) => {

        dispatch(fetchWebsiteSettingDataRequest());
        try {

            let response = await fetch(`${host}/api/master/website-setting`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchWebsiteSettingDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchWebsiteSettingDataFailure(error.message));
        }
    }



// time slot
export const fetchCmsDataRequest = () => ({
    type: "FETCH_CMS_DATA_REQUEST",
});

export const fetchCmsDataSuccess = (data) => ({
    type: "FETCH_CMS_DATA_SUCCESS",
    payload: data,
});

export const fetchCmsDataFailure = (error) => ({
    type: "FETCH_CMS_DATA_FAILURE",
    payload: error,
});

export const getCmsData = () =>

    async (dispatch) => {

        dispatch(fetchCmsDataRequest());
        try {

            let response = await fetch(`${host}/api/master/cms`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchCmsDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchCmsDataFailure(error.message));
        }
    }


// time slot
export const fetchGoogleMeetDataRequest = () => ({
    type: "FETCH_GOOGLE_MEET_DATA_REQUEST",
});

export const fetchGoogleMeetDataSuccess = (data) => ({
    type: "FETCH_GOOGLE_MEET_DATA_SUCCESS",
    payload: data,
});

export const fetchGoogleMeetDataFailure = (error) => ({
    type: "FETCH_GOOGLE_MEET_DATA_FAILURE",
    payload: error,
});

export const getGoogleMeetData = () =>

    async (dispatch) => {

        dispatch(fetchGoogleMeetDataRequest());
        try {

            let response = await fetch(`${host}/api/web/create-meetings`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchGoogleMeetDataSuccess(data));

        } catch (error) {
            dispatch(fetchGoogleMeetDataFailure(error.message));
        }
    }


// About US
export const fetchAboutUsMainDataRequest = () => ({
    type: "FETCH_ABOUT_US_MAIN_DATA_REQUEST",
});

export const fetchAboutUsMainDataSuccess = (data) => ({
    type: "FETCH_ABOUT_US_MAIN_DATA_SUCCESS",
    payload: data,
});

export const fetchAboutUsMainDataFailure = (error) => ({
    type: "FETCH_ABOUT_US_MAIN_DATA_FAILURE",
    payload: error,
});

export const getAboutUsMainData = () =>

    async (dispatch) => {

        dispatch(fetchAboutUsMainDataRequest());
        try {

            let response = await fetch(`${host}/api/web/about-us-data`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchAboutUsMainDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchAboutUsMainDataFailure(error.message));
        }
    }



// About US SECOND SEC
export const fetchAboutUsSecondSecDataRequest = () => ({
    type: "FETCH_ABOUT_US_SECOND_SEC_DATA_REQUEST",
});

export const fetchAboutUsSecondSecDataSuccess = (data) => ({
    type: "FETCH_ABOUT_US_SECOND_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchAboutUsSecondSecDataFailure = (error) => ({
    type: "FETCH_ABOUT_US_SECOND_SEC_DATA_FAILURE",
    payload: error,
});

export const getAboutUsSecondSecData = () =>

    async (dispatch) => {

        dispatch(fetchAboutUsSecondSecDataRequest());
        try {

            let response = await fetch(`${host}/api/web/about-us-second-section-data`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchAboutUsSecondSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchAboutUsSecondSecDataFailure(error.message));
        }
    }



// About US THIRD SEC
export const fetchAboutUsThirdSecDataRequest = () => ({
    type: "FETCH_ABOUT_US_THIRD_SEC_DATA_REQUEST",
});

export const fetchAboutUsThirdSecDataSuccess = (data) => ({
    type: "FETCH_ABOUT_US_THIRD_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchAboutUsThirdSecDataFailure = (error) => ({
    type: "FETCH_ABOUT_US_THIRD_SEC_DATA_FAILURE",
    payload: error,
});

export const getAboutUsThirdSecData = () =>

    async (dispatch) => {

        dispatch(fetchAboutUsThirdSecDataRequest());
        try {

            let response = await fetch(`${host}/api/web/about-us-third-section-data`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchAboutUsThirdSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchAboutUsThirdSecDataFailure(error.message));
        }
    }



// About US four SEC
export const fetchAboutUsFourSecDataRequest = () => ({
    type: "FETCH_ABOUT_US_FOUR_SEC_DATA_REQUEST",
});

export const fetchAboutUsFourSecDataSuccess = (data) => ({
    type: "FETCH_ABOUT_US_FOUR_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchAboutUsFourSecDataFailure = (error) => ({
    type: "FETCH_ABOUT_US_FOUR_SEC_DATA_FAILURE",
    payload: error,
});

export const getAboutUsFourSecData = () =>

    async (dispatch) => {

        dispatch(fetchAboutUsFourSecDataRequest());
        try {

            let response = await fetch(`${host}/api/web/about-us-four-section-data`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchAboutUsFourSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchAboutUsFourSecDataFailure(error.message));
        }
    }


// About US six SEC
export const fetchAboutUsSixSecDataRequest = () => ({
    type: "FETCH_ABOUT_US_SIX_SEC_DATA_REQUEST",
});

export const fetchAboutUsSixSecDataSuccess = (data) => ({
    type: "FETCH_ABOUT_US_SIX_SEC_DATA_SUCCESS",
    payload: data,
});

export const fetchAboutUsSixSecDataFailure = (error) => ({
    type: "FETCH_ABOUT_US_SIX_SEC_DATA_FAILURE",
    payload: error,
});

export const getAboutUsSixSecData = () =>

    async (dispatch) => {

        dispatch(fetchAboutUsSixSecDataRequest());
        try {

            let response = await fetch(`${host}/api/web/about-us-six-section-data`, {
                method: "GET",

            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchAboutUsSixSecDataSuccess(desired_data));

        } catch (error) {
            dispatch(fetchAboutUsSixSecDataFailure(error.message));
        }
    }


// get profile data
export const fetchChatroomListRequest = () => ({
    type: "FETCH_CHATROOM_LIST_REQUEST",
});

export const fetchChatroomListSuccess = (data) => ({
    type: "FETCH_CHATROOM_LIST_SUCCESS",
    payload: data,
});

export const fetchChatroomListFailure = (error) => ({
    type: "FETCH_CHATROOM_LIST_FAILURE",
    payload: error,
});

export const getChatroomList = (authToken) =>

    async (dispatch) => {

        dispatch(fetchChatroomListRequest());
        try {

            let response = await fetch(`${host}/api/web/chatroom-list`, {
                method: "GET",
                headers: {
                    "x-auth-token": authToken, // Custom header with the token
                },
            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchChatroomListSuccess(desired_data));

        } catch (error) {
            dispatch(fetchChatroomListFailure(error.message));
        }
    }



// get profile data
export const fetchChatroomDetailsRequest = () => ({
    type: "FETCH_CHATROOM_DETAIL_DATA_REQUEST",
});

export const fetchChatroomDetailsSuccess = (data) => ({
    type: "FETCH_CHATROOM_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchChatroomDetailsFailure = (error) => ({
    type: "FETCH_CHATROOM_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getChatroomDetails = (authToken, chatroomId) =>

    async (dispatch) => {

        dispatch(fetchChatroomDetailsRequest());
        try {

            let response = await fetch(`${host}/api/web/chatroom-details?chatroomId=${chatroomId}`, {
                method: "GET",
                headers: {
                    "x-auth-token": authToken, // Custom header with the token
                },
            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchChatroomDetailsSuccess(desired_data));

        } catch (error) {
            dispatch(fetchChatroomDetailsFailure(error.message));
        }
    }


// get profile data
export const fetchMessageListRequest = () => ({
    type: "FETCH_MESSAGE_LIST_REQUEST",
});

export const fetchMessageListSuccess = (data) => ({
    type: "FETCH_MESSAGE_LIST_SUCCESS",
    payload: data,
});

export const fetchMessageListFailure = (error) => ({
    type: "FETCH_MESSAGE_LIST_FAILURE",
    payload: error,
});

export const getMessageList = (authToken, chatroomId) =>

    async (dispatch) => {

        dispatch(fetchMessageListRequest());
        try {

            let response = await fetch(`${host}/api/web/message-list?chatroomId=${chatroomId}`, {
                method: "GET",
                headers: {
                    "x-auth-token": authToken, // Custom header with the token
                },
            });


            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchMessageListSuccess(desired_data));

        } catch (error) {
            dispatch(fetchMessageListFailure(error.message));
        }
    }



export const fetchMeetingRecordingDataRequest = () => ({
    type: "FETCH_MEETING_REC_DATA_REQUEST",
});

export const fetchMeetingRecordingDataSuccess = (data) => ({
    type: "FETCH_MEETING_REC_DATA_SUCCESS",
    payload: data,
});

export const fetchMeetingRecordingDataFailure = (error) => ({
    type: "FETCH_MEETING_REC_DATA_FAILURE",
    payload: error,
});

export const getMeetingRecordingData = (meetingId, page) =>

    async (dispatch) => {

        dispatch(fetchMeetingRecordingDataRequest());

        const API_KEY = process.env.REACT_APP_VIDEO_SDK_TOKEN; // Replace with your API Key
        const API_URL = `https://api.videosdk.live/v2/recordings?roomId=${meetingId}&page=${page}`;

        try {

            const response = await fetch(API_URL, {
                method: "GET",
                headers: {
                    Authorization: API_KEY, // API Key for authentication
                    "Content-Type": "application/json"
                }
            });

            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            // console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchMeetingRecordingDataSuccess(data));

        } catch (error) {
            dispatch(fetchMeetingRecordingDataFailure(error.message));
        }
    }



export const fetchMeetingStartRecordingDataSuccess = (data) => ({
    type: "FETCH_START_MEETING_DATA_SUCCESS",
    payload: data,
});

export const fetchMeetingStartRecordingDataFailure = (error) => ({
    type: "FETCH_START_MEETING_DATA_FAILURE",
    payload: error,
});

export const postStartRecordingData = (meetingId) =>

    async (dispatch) => {

       
        const API_KEY = process.env.REACT_APP_VIDEO_SDK_TOKEN; // Replace with your API Key
        const API_URL = `https://api.videosdk.live/v2/recordings/start`;

        try {

            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    Authorization: API_KEY, // API Key for authentication
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "roomId" : meetingId,
                   
                }),
            });

            // console.log("response", await response.json());


            if (!response.ok) {
                throw new Error('Please enter correct URL.');
            }
            const data = await response.json();
            console.log('datais', data);
            let desired_data = data?.data;
            // console.log('desired_data', desired_data)

            dispatch(fetchMeetingStartRecordingDataSuccess(data));

        } catch (error) {
            dispatch(fetchMeetingStartRecordingDataFailure(error.message));
        }
    }

